export const pageRoutes = {
  chat: '/chat',
  version: '/version',
  notFound: '/chat',
};
